import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";
import Brightness1 from "@material-ui/icons/Brightness1";

import TextField from "app/components/form/TextField";
import { DummyCardCQualifications } from "app/app.constants";
import { CARD_FORM } from "features/planner/planner.constants";
import { getQualificationsFromState } from "features/planner/planner.selectors";

const DummyCardForm = ({ handleSubmit, qualifications }) => {
  const allQualifications = qualifications.concat(DummyCardCQualifications);

  return (
    <form onSubmit={handleSubmit} id={CARD_FORM.ID}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Field
            autoFocus
            fullWidth
            label="Name"
            component={TextField}
            name={CARD_FORM.NAME}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            select
            label="Color"
            component={TextField}
            name={CARD_FORM.BACK_COLOR}
          >
            <MenuItem value={null}>
              <Grid item>None</Grid>
            </MenuItem>
            {allQualifications
              .sortBy(qualification => qualification.get("name"))
              .map((qualification, index) => (
                <MenuItem key={index} value={qualification.get("backColor")}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <Grid item container alignItems="center">
                        <Brightness1
                          style={{ color: qualification.get("backColor") }}
                        />
                      </Grid>
                    </Grid>
                    <Grid item>{qualification.get("name")}</Grid>
                  </Grid>
                </MenuItem>
              ))}
          </Field>
        </Grid>
      </Grid>
    </form>
  );
};

export default compose(
  connect(state => ({
    qualifications: getQualificationsFromState(state),
  })),
  React.memo,
)(DummyCardForm);
